import { useInfiniteQuery } from 'react-query';
import { v4 as uuidv4 } from 'uuid';
import { ApiCollectionResponse } from 'types/api_response';
import { baseApiUrl, fetcher } from 'data_sources/constants';
import { ServerErrorResponse } from 'data_sources/constants';
import { PolicyAcknowledgmentFullAuditResult } from 'views/App/Portal/Reporting/PolicyAcknowledgments/_types/policyAcknowledgements';

export default function usePolicyAcknowledgmentReport<T extends PolicyAcknowledgmentFullAuditResult>(
  orgId: string,
  params: Record<string, any> = {},
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexipub/reports/v1/organizations/${orgId}/reports/policy-acknowledgments/full-audit`;
  return useInfiniteQuery<ApiCollectionResponse<T>, Error>(
    ['reporting_policy_acknowledgments', orgId, params],
    async ({ pageParam = 0, signal }): Promise<ApiCollectionResponse<T>> => {
      const paramString = new URLSearchParams(
        Object.entries({
          ...params,
          offset: pageParam,
        })
          .filter(([_k, v]) => v != null)
          .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
      ).toString();
      const data: ApiCollectionResponse<T> = await fetcher({
        method: 'get',
        url: `${url}?${paramString}`,
        options: { signal },
      }).catch((err) => {
        if (onError) onError(err);
        throw err;
      });

      return data;
    },
    {
      getNextPageParam: (lastPage) => {
        if (
          lastPage?.offset != null &&
          lastPage?.count != null &&
          lastPage.offset < lastPage.count &&
          Array.isArray(lastPage.content) &&
          lastPage.content.length > 0
        ) {
          return lastPage.offset;
        }
        return undefined;
      },
      ...options,
    }
  );
}
